export enum SSOErrorsEnum {
  SIGN_IN_DEFAULT = 'Ошибка при входе',
  GET_ACCOUNT_INFO = 'Ошибка при получении данных пользователя.',
  REFRESH = 'Ошибка refresh',
  LOGOUT = 'Ошибка при выходе.',
  SEND_CODE = 'Ошибка отправки кода подтвеждения.',
  EMAIL_CONFIRM = 'Ошибка подтверждения email.',
  CHANGE_PASSWORD = 'Ошибка смены пароля.',
}

export const SSOErrors = {
  SIGN_UP: {
    409: 'Пользователь уже существует.',
    400: 'Номер телефона или email уже используется.',
  },
  SIGN_IN: {
    400: 'Номер телефона или email введен не верно.',
    401: 'Не верный пароль.',
    404: 'Пользователь не найден.',
    423: 'Аккаунт временно заблокирован из-за множества неудачных попыток входа. Повторите позже.',
  },
};
